// extracted by mini-css-extract-plugin
export var finish = "style-module--finish--2ldd7";
export var finish_head = "style-module--finish_head--3j2ke";
export var finish_head_suptitle = "style-module--finish_head_suptitle--1qdZE";
export var finish_head_title = "style-module--finish_head_title--3CGIg";
export var finish_main_title = "style-module--finish_main_title--3kVuW";
export var finish_main_links = "style-module--finish_main_links--1ggkb";